// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import getTriggerFields from './getTriggerFields'
import compareTriggerValuesWithSegmentEnd from './compareTriggerValuesWithSegmentEnd'

// formValues is the Bulk Edits - Site Mode submit values.

// we'll take these values and compare them to the selected segment ends' data
// stored in project summary to determine if they should trigger a callsign cascade.

// NOTE - when detecting the trigger fields from Path Details we can simply compare
// initial and submit values from the redux-form. However, through bulk edits,
// we are comparing the submit values to every selected segment end.
// Since the bulk edits form initializes empty, we have no 'initial' values to speak of.

const compareBulkSiteChangesForCallsignCascade = formValues => dispatch => {
  const triggerFields = dispatch(getTriggerFields(formValues))

  const callsignCascadeTriggerData = dispatch(compareTriggerValuesWithSegmentEnd(triggerFields))

  return (
    callsignCascadeTriggerData.length
      ? callsignCascadeTriggerData
      : null
  )
}

export default compareBulkSiteChangesForCallsignCascade
